import React from 'react';
import { Linkedin } from 'lucide-react';
import { footerData } from '../mock';

export const Footer = () => {
  return (
    <footer style={{ background: 'var(--bg-secondary)', borderTop: '1px solid var(--border-light)', padding: '60px 0 30px' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginBottom: '60px' }}>
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>YFT Group</h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>{footerData.tagline}</p>
          </div>

          <div>
            <h4 className="body-regular" style={{ fontWeight: 600, marginBottom: '16px' }}>Quick Links</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {footerData.links.map((link, index) => (
                <li key={index} style={{ marginBottom: '12px' }}>
                  <a href={link.href} className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s ease' }}>{link.text}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="body-regular" style={{ fontWeight: 600, marginBottom: '16px' }}>Connect</h4>
            <div style={{ display: 'flex', gap: '16px' }}>
              {footerData.social.map((social, index) => (
                <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" style={{ width: '40px', height: '40px', border: '1px solid var(--border-medium)', borderRadius: '0px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease' }}>
                  <Linkedin size={20} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div style={{ height: '1px', background: 'var(--border-light)', margin: '40px 0' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>{footerData.copyright}</p>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>{footerData.credits}</p>
        </div>
      </div>
    </footer>
  );
};